import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/followupForm', // 用户（patient）通过小程序/URL链接，打开表单页面填写内容；不需登录
      name: 'followupForm',
      component: () => import('./views/followupForm.vue'),
    },  
    {
      path: '/WxRedirect', // SMS链接，跳转小程序页面，需要中转先跳转到WEB页面，android平台需要；不需登录
      name: 'WxRedirect',
      component: () => import('./views/WxRedirect.vue'),
    },   
    {
      path: '/bindPhone', // 关注公众号后，点击绑定手机号，用于接收通知等；不需登录
      name: 'bindPhone',
      component: () => import('./views/bindPhone.vue'),
    }, 
    {
      path: '/home',
      name: 'home',
      redirect: '/home/intell',
      component: () => import( './views/Home.vue'),
      children: [
        {
          path: 'homeInfo',
          name: 'homeInfo',
          component: () => import( './components/HomeInfoPage.vue'),
          meta: {
            title: '统计',
            auths:['data_count']
          },
        },
        {
          path: 'operation',
          name: 'operation',
          component: () => import('./views/Operation.vue'),
          meta: {
            title: '手术预约',
            auths:['operation_order'],
            //keepAlive: true
          },
        },
        
        // 美容预约登记
        {
          path: 'cosmetregister',
          name: 'cosmetregister',
          component: () => import('./views/cosmetregister.vue'),
          meta: {
            title: '美容登记',
            auths:['cosmet_registration'],
            //keepAlive: true
          },
        },       
        // 随访
        {
          path: 'followup',
          name: 'followup',
          component: () => import('./views/followup.vue'),
          meta: {
            title: '随访',
            auths:['followup'],
            //keepAlive: true
          },
        },   

        {
          path: 'hairdressing',
          name: 'hairdressing',
          component: () => import('./views/Hairdressing.vue'),
          meta: {
              title: '美容',
              auths:['hairdressing_order'],
              //keepAlive: true
          },
        },        
        {
          path: 'patients',
          name: 'patients',
          component: () => import('./views/Patients.vue'),
          meta: {
            title: '患者列表',
            auths:['patients_list'],
            keepAlive: true
          },
        },
        // 2026-0528， 增加科研队列页面，页面基础来自于患者列表 Patients.vue
        {
          path: 'cohort',
          name: 'cohort',
          component: () => import('./views/Cohort.vue'),
          meta: {
            title: '科研队列',
            auths:['cohort'],
            keepAlive: true
          },
        },
        {
          path: 'quicksnap',
          name: 'quicksnap',
          component: () => import('./views/Quicksnap.vue'),
        },
        {
          path: 'intell',
          name: 'Intell',
          component: () => import('./views/Intell.vue'),
          meta: {
            title: '诊断',
            auths:['diagnoses_image'],
            //keepAlive: true
          },
        },
        {
          path: 'count',
          name: 'Count',
          component: () => import('./views/Count.vue'),
          
        },
        {
          path: 'search',
          name: 'Search',
          component: () => import('./views/Search.vue'),
          meta: {
            keepAlive: true
          },
        },
        {
          path: 'image',
          name: 'ImageManage',
          component: () => import('./views/ImageManage.vue'),
          meta: {
            title: '影像管理',
            auths:['image_manage'],
            keepAlive: true
          },
        },
        {
          path: 'user',
          name: 'User',
          component: () => import('./views/User.vue'),
          meta: {
            title: '个人中心',
            auths:['user_detail']
          },
          children: [
            {
              path: 'account',
              name: 'Account',
              component: () => import( './components/UserAccount.vue'),
            },
            {
              path: 'setting',
              name: 'Setting',
              component: () => import( './components/UserSetting.vue'),
            },
            {
              path: 'myTemplate',
              name: 'myTemplate',
              component: () => import( './components/myTemplate.vue'),
            },
              {
                  path: 'templateSetting',
                  name: 'templateSetting',
                  component: () => import( './components/templateSetting.vue'),
              },
            {
              path: 'opinion',
              name: 'Opinion',
              component: () => import( './components/UserOpinion.vue'),
            },
            {
              path: 'result',
              name: 'Result',
              component: () => import( './components/UserOpinionResult.vue'),
            },
          ]
        },
        {
          path: 'details',
          name: 'details',
          component: () => import('./components/PatientDiagnoseRecord.vue')
        }
      ],
    }
  ]
});
